import React from 'react';
import styled from 'styled-components';
import { PageContentWrapper } from '../main/LayoutStyles';
import { useTheme } from 'styled-components';

const TermsContent = styled.article`
    background-color: ${({ theme }) => theme.colors.white};
    padding: ${({ theme }) => theme.spacing.xl};
    border-radius: ${({ theme }) => theme.borderRadius};
    box-shadow: ${({ theme }) => theme.shadows.lg};
    max-width: 900px;
    margin: ${({ theme }) => theme.spacing.lg} auto;
    font-size: 0.9rem;
    line-height: 1.7;
    color: ${({ theme }) => theme.colors.textMedium};
`;

const CardTitle = styled.h1`
    font-size: 2rem;
    font-weight: 700;
    color: ${({ theme }) => theme.colors.primaryDarker};
    text-align: center;
    margin-bottom: ${({ theme }) => theme.spacing.md};
`;

const SectionTitle = styled.h2`
    font-size: 1.25rem;
    color: ${({ theme }) => theme.colors.textDark};
    margin-top: ${({ theme }) => theme.spacing.lg};
    margin-bottom: ${({ theme }) => theme.spacing.sm};
    padding-bottom: ${({ theme }) => theme.spacing.xs};
    border-bottom: 1px solid ${({ theme }) => theme.colors.borderColor};
`;

const StyledList = styled.ul`
    padding-left: ${({ theme }) => theme.spacing.lg};
    margin-bottom: ${({ theme }) => theme.spacing.md};

    li {
        margin-bottom: ${({ theme }) => theme.spacing.sm};
    }
`;

const Paragraph = styled.p`
    margin-bottom: ${({ theme }) => theme.spacing.md};
`;

const StrongHighlight = styled.strong`
    color: ${({ theme }) => theme.colors.danger};
    font-weight: 700;
`;


const TermsOfServicePage = () => {
    const theme = useTheme();
    return (
        <PageContentWrapper className="custom-scrollbar">
            <TermsContent>
                <CardTitle>Regulamin Aplikacji ePsycholog</CardTitle>

                <Paragraph style={{ textAlign: 'center', marginTop: `-${theme.spacing.sm}` }}>
                    <strong>Obowiązuje od dnia:</strong> 15.06.2025
                </Paragraph>

                <SectionTitle>§ 1. Postanowienia Wstępne</SectionTitle>
                <StyledList>
                    <li>Niniejszy regulamin (zwany dalej „Regulaminem”) określa zasady i warunki świadczenia usług drogą elektroniczną za pośrednictwem aplikacji internetowej ePsycholog (zwanej dalej „Aplikacją”), dostępnej pod adresem www.epsycholog.app.</li>
                    <li>Kontakt z usługodawcą odbywa się poprzez adres e-mail: web.epsycholog@gmail.com.</li>
                    <li>Każdy użytkownik przed rozpoczęciem korzystania z Aplikacji jest zobowiązany do zapoznania się z treścią niniejszego Regulaminu. Rozpoczęcie korzystania z Usług jest równoznaczne z pełną akceptacją warunków Regulaminu.</li>
                    <li>
                        <strong>Definicje:</strong>
                        <StyledList style={{ marginTop: '0.5rem' }}>
                            <li><strong>Aplikacja</strong> – aplikacja internetowa ePsycholog, służąca jako narzędzie wspierające dobrostan psychiczny.</li>
                            <li><strong>Użytkownik</strong> – każda osoba fizyczna, która ukończyła 18 lat i posiada pełną zdolność do czynności prawnych, korzystająca z Aplikacji.</li>
                            <li><strong>Gość</strong> – Użytkownik korzystający z ograniczonych funkcji Aplikacji bez zakładania Konta.</li>
                            <li><strong>Użytkownik Zarejestrowany</strong> – Użytkownik, który pomyślnie założył Konto w Aplikacji.</li>
                            <li><strong>Konto</strong> – indywidualny panel Użytkownika w Aplikacji, zabezpieczony loginem i hasłem.</li>
                            <li><strong>Usługi</strong> – wszelkie funkcjonalności udostępniane przez Usługodawcę w ramach Aplikacji.</li>
                        </StyledList>
                    </li>
                </StyledList>

                <SectionTitle>§ 2. Kluczowe Zastrzeżenia i Charakter Aplikacji</SectionTitle>
                <StyledList>
                    <li><StrongHighlight>APLIKACJA EPSYCHOLOG NIE JEST WYROBEM MEDYCZNYM, NIE ŚWIADCZY PROFESJONALNYCH USŁUG PSYCHOLOGICZNYCH, PSYCHIATRYCZNYCH ANI TERAPEUTYCZNYCH.</StrongHighlight></li>
                    <li>Treści, narzędzia i funkcjonalności dostępne w Aplikacji (w tym Czat AI, Testy, Ćwiczenia, Baza Wiedzy) mają <strong>charakter wyłącznie informacyjny, edukacyjny i wspierający</strong>. Nie stanowią one diagnozy medycznej, porady psychologicznej, opinii lekarskiej ani żadnej formy terapii.</li>
                    <li><StrongHighlight>Aplikacja w żadnym wypadku nie zastępuje bezpośredniego kontaktu z wykwalifikowanym specjalistą zdrowia psychicznego (psychologiem, psychoterapeutą, psychiatrą) ani lekarzem.</StrongHighlight></li>
                    <li><StrongHighlight>W PRZYPADKU KRYZYSU PSYCHICZNEGO, MYŚLI SAMOBÓJCZYCH, ZAGROŻENIA ŻYCIA LUB ZDROWIA, NALEŻY NIEZWŁOCZNIE SKONTAKTOWAĆ SIĘ Z NUMEREM ALARMOWYM 112 LUB NAJBLIŻSZĄ PLACÓWKĄ MEDYCZNĄ LUB SKORZYSTAĆ Z JEDNEGO Z TELEFONÓW ZAUFANIA.</StrongHighlight> Aplikacja nie jest narzędziem do interwencji kryzysowej.</li>
                    <li>Usługodawca nie ponosi żadnej odpowiedzialności za decyzje życiowe, zdrowotne lub terapeutyczne podjęte przez Użytkownika na podstawie informacji uzyskanych w Aplikacji. Całkowite ryzyko i odpowiedzialność za wykorzystanie treści i narzędzi Aplikacji spoczywa na Użytkowniku.</li>
                </StyledList>

                <SectionTitle>§ 3. Warunki Techniczne</SectionTitle>
                <StyledList>
                    <li>Do prawidłowego korzystania z Aplikacji wymagane jest posiadanie urządzenia z dostępem do Internetu oraz aktualnej wersji przeglądarki internetowej (np. Chrome, Firefox, Safari, Edge).</li>
                    <li>Usługodawca nie ponosi odpowiedzialności za problemy w funkcjonowaniu Aplikacji wynikające z niespełnienia przez Użytkownika powyższych wymogów technicznych.</li>
                </StyledList>

                <SectionTitle>§ 4. Rejestracja i Konto Użytkownika</SectionTitle>
                <StyledList>
                    <li>Utworzenie Konta jest dobrowolne i bezpłatne.</li>
                    <li>Rejestracja jest możliwa poprzez formularz (wymaga podania nazwy użytkownika, adresu e-mail i hasła) lub za pośrednictwem zewnętrznych dostawców tożsamości (OAuth), takich jak Google czy Facebook.</li>
                    <li>Użytkownik jest zobowiązany do podania prawdziwych i aktualnych danych podczas rejestracji oraz do zachowania poufności swojego hasła.</li>
                    <li>Usługodawca nie ponosi odpowiedzialności za skutki udostępnienia przez Użytkownika danych dostępowych do Konta osobom trzecim.</li>
                    <li>Użytkownik może w każdej chwili usunąć swoje Konto, kontaktując się z Usługodawcą pod adresem e-mail: web.epsycholog@gmail.com.</li>
                    <li>Usługodawca zastrzega sobie prawo do zawieszenia lub usunięcia Konta Użytkownika w przypadku rażącego naruszenia postanowień niniejszego Regulaminu.</li>
                </StyledList>

                <SectionTitle>§ 5. Korzystanie z Aplikacji jako Gość</SectionTitle>
                <StyledList>
                    <li>Część funkcjonalności Aplikacji jest dostępna dla Gości bez konieczności zakładania Konta.</li>
                    <li>Dane wprowadzane przez Gościa (np. historia czatu, wpisy w dzienniku) są <strong>zapisywane wyłącznie lokalnie w pamięci przeglądarki</strong> na urządzeniu Gościa.</li>
                    <li><StrongHighlight>Usługodawca nie ma dostępu do danych Gościa i nie ponosi żadnej odpowiedzialności za ich utratę</StrongHighlight>, która może nastąpić w wyniku np. wyczyszczenia danych przeglądarki, zmiany urządzenia lub awarii technicznej.</li>
                    <li>W celu trwałego zapisywania danych i dostępu do nich z różnych urządzeń, Gość powinien założyć Konto.</li>
                </StyledList>

                <SectionTitle>§ 6. Szczegółowy Opis i Zasady Korzystania z Usług</SectionTitle>
                <StyledList>
                    <li><strong>Czat AI:</strong>
                        <StyledList style={{ marginTop: '0.5rem' }}>
                            <li>Usługa polega na prowadzeniu rozmowy z automatycznym modelem językowym (AI).</li>
                            <li><strong>Czat AI nie jest rozmową z człowiekiem ani terapeutą.</strong> Jego odpowiedzi są generowane automatycznie i mogą być niedokładne, niepełne lub nieadekwatne. Celem AI jest wspieranie autorefleksji, a nie udzielanie porad.</li>
                        </StyledList>
                    </li>
                    <li><strong>Dziennik Refleksji:</strong>
                        <StyledList style={{ marginTop: '0.5rem' }}>
                            <li>Umożliwia zapisywanie prywatnych notatek oraz śledzenie nastroju i innych wskaźników.</li>
                            <li>Dane Użytkowników Zarejestrowanych są przechowywane na serwerach Usługodawcy w formie zaszyfrowanej.</li>
                        </StyledList>
                    </li>
                    <li><strong>Ćwiczenia i Testy:</strong>
                        <StyledList style={{ marginTop: '0.5rem' }}>
                            <li>Aplikacja oferuje ćwiczenia relaksacyjne, oddechowe i inne oraz testy psychologiczne o charakterze edukacyjnym.</li>
                            <li><strong>Wyniki testów mają charakter wyłącznie informacyjny i nie stanowią profesjonalnej diagnozy psychologicznej.</strong></li>
                        </StyledList>
                    </li>
                    <li><strong>Baza Wiedzy:</strong>
                        <StyledList style={{ marginTop: '0.5rem' }}>
                            <li>Artykuły i materiały mają charakter wyłącznie edukacyjny i nie mogą być traktowane jako porada specjalistyczna.</li>
                        </StyledList>
                    </li>
                    <li><strong>Opinie i Rezerwacja Wizyt u Specjalistów:</strong>
                        <StyledList style={{ marginTop: '0.5rem' }}>
                            <li>Aplikacja może udostępniać platformę do przeglądania profili niezależnych specjalistów (psychologów, terapeutów) oraz rezerwacji wizyt.</li>
                            <li><strong>Usługodawca działa jedynie jako pośrednik technologiczny.</strong> Nie jest stroną umowy o świadczenie usług psychologicznych zawieranej między Użytkownikiem a Specjalistą.</li>
                            <li>Usługodawca nie weryfikuje kompetencji ani kwalifikacji Specjalistów i nie ponosi żadnej odpowiedzialności za jakość, skuteczność i skutki usług świadczonych przez Specjalistów znalezionych za pośrednictwem Aplikacji. Wszelkie roszczenia dotyczące usług terapeutycznych należy kierować bezpośrednio do danego Specjalisty.</li>
                        </StyledList>
                    </li>
                </StyledList>

                <SectionTitle>§ 7. Płatności i Usługi Premium</SectionTitle>
                <StyledList>
                    <li>Korzystanie z podstawowych funkcji Aplikacji jest bezpłatne.</li>
                    <li>Usługodawca zastrzega sobie prawo do wprowadzenia w przyszłości opłat za dostęp do wybranych lub wszystkich Usług (np. w formie subskrypcji "Premium").</li>
                    <li>W przypadku wprowadzenia opłat, Użytkownik zostanie o tym poinformowany w sposób jasny i wyraźny, a skorzystanie z płatnej Usługi będzie wymagało jego aktywnej zgody i akceptacji odrębnego regulaminu płatności.</li>
                </StyledList>

                <SectionTitle>§ 8. Prawa i Obowiązki Użytkownika</SectionTitle>
                <StyledList>
                    <li>Użytkownik zobowiązuje się do korzystania z Aplikacji w sposób zgodny z jej przeznaczeniem, niniejszym Regulaminem oraz obowiązującym prawem.</li>
                    <li>
                        Zabronione jest w szczególności:
                        <StyledList style={{ marginTop: '0.5rem' }}>
                            <li>Dostarczanie treści o charakterze bezprawnym, obraźliwym lub naruszającym dobra osobiste osób trzecich.</li>
                            <li>Podejmowanie prób zakłócenia działania Aplikacji, uzyskania nieautoryzowanego dostępu do danych innych Użytkowników lub stosowania inżynierii wstecznej.</li>
                            <li>Wykorzystywanie Aplikacji do celów komercyjnych bez zgody Usługodawcy.</li>
                        </StyledList>
                    </li>
                </StyledList>

                <SectionTitle>§ 9. Odpowiedzialność Usługodawcy</SectionTitle>
                <StyledList>
                    <li>Usługodawca dokłada wszelkich starań, aby zapewnić ciągłe i poprawne działanie Aplikacji, jednak nie gwarantuje jej nieprzerwanej dostępności. Mogą wystąpić przerwy techniczne lub awarie.</li>
                    <li><strong>Aplikacja jest dostarczana w stanie "tak jak jest" ("as is") oraz "w miarę dostępności" ("as available"). Usługodawca wyłącza wszelkie rękojmie i gwarancje, zarówno wyraźne, jak i dorozumiane.</strong></li>
                    <li>Odpowiedzialność Usługodawcy z tytułu jakichkolwiek szkód poniesionych przez Użytkownika w związku z korzystaniem z Aplikacji (w tym utraty danych, szkód materialnych i niematerialnych) jest ograniczona do minimalnej kwoty dopuszczalnej przez bezwzględnie obowiązujące przepisy prawa.</li>
                    <li>Usługodawca nie ponosi odpowiedzialności za treści zamieszczane przez Użytkowników ani za linki do zewnętrznych stron internetowych, które mogą znaleźć się w Aplikacji.</li>
                </StyledList>

                <SectionTitle>§ 10. Własność Intelektualna</SectionTitle>
                <StyledList>
                    <li>Wszelkie prawa do Aplikacji, w tym jej nazwa, logo, interfejs, kod źródłowy, grafiki i treści (z wyłączeniem treści wprowadzanych przez Użytkowników) należą do Usługodawcy i są chronione prawem autorskim.</li>
                    <li>Użytkownik zachowuje pełnię praw autorskich do treści, które wprowadza do Aplikacji (np. wpisy w Dzienniku).</li>
                    <li>Poprzez wprowadzenie treści, Użytkownik udziela Usługodawcy niewyłącznej, nieodpłatnej, ogólnoświatowej licencji na przechowywanie, przetwarzanie (w tym szyfrowanie), kopiowanie i wyświetlanie tych treści, wyłącznie w celu świadczenia Usług na rzecz tego Użytkownika.</li>
                </StyledList>

                <SectionTitle>§ 11. Przetwarzanie Danych Osobowych</SectionTitle>
                <StyledList>
                    <li>Zasady przetwarzania danych osobowych Użytkowników określa <strong>Polityka Prywatności</strong>, stanowiąca integralną część niniejszego Regulaminu.</li>
                    <li>Użytkownik, akceptując Regulamin, potwierdza zapoznanie się z Polityką Prywatności.</li>
                </StyledList>

                <SectionTitle>§ 12. Postępowanie Reklamacyjne</SectionTitle>
                <StyledList>
                    <li>Wszelkie reklamacje dotyczące działania Aplikacji należy zgłaszać drogą elektroniczną na adres: web.epsycholog@gmail.com.</li>
                    <li>Reklamacja powinna zawierać co najmniej dane identyfikujące Użytkownika (nazwa użytkownika lub e-mail) oraz szczegółowy opis problemu.</li>
                    <li>Usługodawca rozpatrzy reklamację w terminie 14 dni roboczych od jej otrzymania.</li>
                </StyledList>

                <SectionTitle>§ 13. Zmiany w Regulaminie</SectionTitle>
                <StyledList>
                    <li>Usługodawca zastrzega sobie prawo do zmiany niniejszego Regulaminu z ważnych przyczyn (np. zmiana przepisów prawa, wprowadzenie nowych funkcjonalności, zmiana modelu biznesowego).</li>
                    <li>O wszelkich zmianach Użytkownicy Zarejestrowani zostaną poinformowani drogą elektroniczną na podany przy rejestracji adres e-mail, z co najmniej 14-dniowym wyprzedzeniem.</li>
                    <li>Brak sprzeciwu lub dalsze korzystanie z Aplikacji po wejściu zmian w życie jest równoznaczne z ich akceptacją.</li>
                </StyledList>

                <SectionTitle>§ 14. Postanowienia Końcowe</SectionTitle>
                <StyledList>
                    <li>W sprawach nieuregulowanych niniejszym Regulaminem zastosowanie mają przepisy prawa polskiego.</li>
                    <li>Wszelkie spory wynikające z realizacji Usług będą rozstrzygane przez sąd właściwy dla siedziby Usługodawcy.</li>
                    <li>Jeżeli którekolwiek postanowienie Regulaminu zostanie uznane za nieważne, pozostałe postanowienia pozostają w mocy.</li>
                </StyledList>
            </TermsContent>
        </PageContentWrapper>
    );
};

export default TermsOfServicePage;